module.exports = __webpack_public_path__ + "dingbeauty-landing/img/industry_05@1.849ed017.png";